import ChangeRequestsTable from "./ChangeRequestsTable";
export default ChangeRequestsTable;
